import React, { useCallback, useEffect, useState } from 'react';
import { ErrorRetrievingData } from '../../components/ErrorRetrievingData';
import MenuMain from '../../MenuMain';
import api from '../../api/api';
import { AppFooter } from '../../AppFooter';
import { FormCotacao } from '../../components/FormCotacao';

export default function EditarCotacaoPage(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [errorGettingCotacao, setErrorGettingCotacao] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [cotacao, setCotacao] = useState({});
    const id = props.match.params.id;

    const getCotacao = useCallback(async () => {
        setIsLoading(true);
        try {
            const response = await api.get(`cotacao/${id}`);
            setCotacao({
                id: response.data.id,
                pessoaId: response.data.pessoaId,
                ativo: response.data.ativo,
            });
            setErrorGettingCotacao(false);
        } catch (error) {
            setErrorMessage(error.toString());
            setErrorGettingCotacao(true);
        }
        setIsLoading(false);
    }, [id]);

    useEffect(() => {
        getCotacao();
    }, [getCotacao]);

    return (
        <>
            <MenuMain>
                {errorGettingCotacao ? (
                    <ErrorRetrievingData errorMessage={errorMessage} isLoading={isLoading} />
                ) : (
                    <FormCotacao defaultValues={cotacao} isEditing={true} isLoading={isLoading} />
                )}
            </MenuMain>
            <AppFooter />
        </>
    );
}
